import { Record } from 'immutable';

const EventCollisionMatchRecord = Record({
  createdBy: null,
  agencyName: null,
  eventName: null,
  groupCode: null,
  startDate: null,
  endDate: null,
  property: null,
});

export class EventCollisionMatch extends EventCollisionMatchRecord {
  createdBy: string;
  agencyName: string;
  eventName: string;
  groupCode: string;
  startDate: string;
  endDate: string;
  property: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-collision-match.ts